import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export default class FooterTop extends Component {
  render() {
    return (
      <div
        className={"row"}
        style={{ backgroundColor: "#66cc33", marginTop: 80 }}
      >
        <div className={"col-md-12 text-center"}>
          <h3
            style={{
              padding: 30,
              fontFamily: "'Poppins', sans-serif",
              color: "#FFF",
              fontWeight: "bold"
            }}
          >
            <FontAwesomeIcon icon={["fas", "map-marker-alt"]} color={"#fff"} />{" "}
            Haritada Biz
          </h3>
        </div>
        <div
          className={"col-md-12"}
          style={{ margin: 0, padding: 0, backgroundColor: "#2c2c2c" }}
        >
          <iframe
            title="harita"
            allowFullScreen=""
            frameBorder="0"
            height="450"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1126.50292874458!2d30.553190728287685!3d37.76223629905235!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDQ1JzQ0LjMiTiAzMMKwMzMnMTMuNyJF!5e0!3m2!1str!2str!4v1520429222460"
            style={{ border: 0, width: "100%" }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/FooterTop.js